import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, Platform } from "@ionic/angular";
import { Subject, Subscription } from 'rxjs';
import { NotificationRequest_ShowPopup } from 'src/model/class/general classes/notification-request';
import { LogicLog } from 'src/model/class/general classes/logic-log';
import { iEvent } from 'src/components/shared-components/interfaces/iEvent';
import { EventService } from 'src/service/event.service';
import { PopupAlarm } from 'src/model/class/general classes/popup-alarm';

@Component({
    selector: 'app-popup-alarm',
    templateUrl: './popup-alarm.component.html',
    styleUrls: ['./popup-alarm.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopupAlarmComponent implements OnInit, OnDestroy, iEvent {
  private _logContext: string = "popup-alarm.component";
  @Input() alarmInfo: Subject<NotificationRequest_ShowPopup>;

  public _eventSubscriptions: Array<Subscription> = null;

  public selectedAlarm: LogicLog = null;
  public dupAlarms: Array<LogicLog> = new Array<LogicLog>();
  public otherAlarmsPresent: boolean = false;
  public solveResetValue: string = "";
  public isApp: boolean = false;

  constructor(
    private _modalController: ModalController,
    private _eventService: EventService,
    private _platform: Platform
  ) {
    this.isApp = this._platform.is("ios") || this._platform.is("android");
  }

  ngOnInit(): void {
    this.subscribeEvents();
  }

  ngOnDestroy(): void {
    this.unsubscribeEvents();
  }

  //#region Subscribe to event-service observable
  subscribeEvents(): void {
    this._eventSubscriptions = new Array<Subscription>();

    this._eventSubscriptions.push(
      this._eventService.OnMakeForceLogout.subscribe(() => {
        this._modalController.dismiss();
      })
    );
  }

  unsubscribeEvents(): void {
    for (let sub of this._eventSubscriptions) {
      sub.unsubscribe();
    }
  }
  //#endregion

  /**
   * When clicked, it shows the information of the selected alarm, 
   * the alarms still active of the same type and the buttons to reset or view it.
   * @param alarm alarm to display
   */
  public showAlarm(popupAlarm: PopupAlarm): void {
    this.selectedAlarm = popupAlarm.selectedAlarm;
    this.dupAlarms = popupAlarm.duplicateAlarms;
    this.otherAlarmsPresent = popupAlarm.otherAlarmsPresent;
  }

  /**
   * When a value arrives, it updates solveResetValue 
   * to be passed on to one of its children.
   */
  public solveReset(value: string): void {
    let timeout = setTimeout(() => {
      this.solveResetValue = value;
      clearTimeout(timeout);
    }, 500);
  }
}
